import * as React from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import type { Form } from 'factorial-form'

import type CustomField from 'modules/custom_resources/store/models/customFields/Field'

import Question from '../Question'

type QuestionProps = React.ComponentProps<typeof Question>

interface Props {
  options: Record<string, QuestionProps['options']>
  form: Form
  field: CustomField
  isResponseValues?: boolean
  canReview?: boolean
}

const QuestionsWithoutCategory = ({
  options,
  form,
  field,
  isResponseValues,
  canReview = true,
}: Props) => {
  return (
    <Box flexDirection="row" gap="s24" background="grey100" flexGrow>
      <Question
        fieldName={form.get('name').value}
        fieldType={form.get('field_type').value}
        formField={form.get('value')}
        mandatory={form.get('mandatory').value}
        minValue={+form.get('min_value').value} // +null => 0
        maxValue={+form.get('max_value').value} // +null => 0
        options={options[field.attributes.id] ?? []}
        position={field.attributes.position === null ? null : field.attributes.position + 1}
        readonly={isResponseValues || !canReview}
      />
    </Box>
  )
}

export default QuestionsWithoutCategory
